import { registerModal } from 'features/Modal/ModalRegistry'
import NumbersDisconnectModal from './NumbersDisconnectModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'NUMBERS_DISCONNECT'
registerModal(modalType, NumbersDisconnectModal)

export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersDisconnectModal/NumbersDisconnectModal.action.js